import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import { MadhvacharyaContent } from "./Madhvacharya";
import { VadirajaContent } from "./Vadiraja";
import { GuruParamparaContent } from "./GuruParampara";
import { useLang } from "../i18n/LanguageContext";

const TAB_LABELS = {
  madhva: { en: "Sri Madhvacharya", kn: "ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯ" },
  vadiraja: { en: "Sri Vadiraja Theertha", kn: "ಶ್ರೀ ವಾದಿರಾಜ ತೀರ್ಥ" },
  guru: { en: "Guru Parampara", kn: "ಗುರುಪರಂಪರೆ" },
};
const TAB_IDS = ["madhva", "vadiraja", "guru"];

const Lineage = () => {
  const { lang } = useLang();
  const { search } = useLocation();
  const initial = new URLSearchParams(search).get("tab");
  const initialTab = TAB_IDS.includes(initial) ? initial : TAB_IDS[0];
  const [tab, setTab] = useState(initialTab);

  return (
    <PageLayout>
      {/* Sub-nav */}
      <div className="fixed left-0 right-0 top-24 md:top-[132px] z-30 bg-[#FBF7F0] border-b border-[#D4AF37]/30 backdrop-blur-md" data-testid="lineage-subnav">
        <div className="max-w-6xl mx-auto px-4 lg:px-8 flex flex-wrap justify-center gap-2 py-3">
          {TAB_IDS.map((id) => (
            <button
              key={id}
              onClick={() => setTab(id)}
              className={`px-4 py-2 rounded-full text-xs sm:text-sm font-semibold border transition ${
                tab === id
                  ? "bg-[#B65A14] text-[#FBF7F0] border-[#B65A14]"
                  : "bg-[#FBF7F0] text-[#3B2A1A] border-[#D4AF37]/30 hover:border-[#D4AF37]"
              }`}
              data-testid={`lineage-tab-${id}`}
            >
              {TAB_LABELS[id][lang] || TAB_LABELS[id].en}
            </button>
          ))}
        </div>
      </div>
      <div className="h-[90px] sm:h-[65px]" aria-hidden="true" />
      {tab === "madhva" && <MadhvacharyaContent />}
      {tab === "vadiraja" && <VadirajaContent />}
      {tab === "guru" && <GuruParamparaContent />}
    </PageLayout>
  );
};

export default Lineage;
